const options = {
  loop: false,
  spaceBetween: 10,
  slidesPerView: 'auto',
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
  breakpoints: {
    1024: {
      slidesPerView: 1,
      spaceBetween: 20
    }
  }
}

export default {
  name: 'Slider',

  props: {
    totalSlides: {
      required: true,
      type: Number
    }
  },

  data: function () {
    return {
      swiperComponentOption: options
    }
  }
}
